
export const getUser = ({auth}) => auth.user
export const getIsUserLoaded = ({auth}) => auth.isLoaded
export const getIsLoggedIn = ({auth}) => !!auth.user
